import { AxiosResponse } from "axios";
import { QUERY_CLIENT } from "..";
import Product from "../model/product";
import { QueryKeys } from "./base/react-query";
import { getAxiosInstance } from "./api-utils";
const PRODUCTS = "/products";

export async function getProducts(skipErrorToast?: boolean): Promise<Product[]> {
    const response: AxiosResponse<Product[]> = await getAxiosInstance({ skipErrorInterceptor: skipErrorToast }).get(PRODUCTS);
    return response.data;
}

export async function getProduct(id: number): Promise<Product> {
    const response: AxiosResponse<Product> = await getAxiosInstance().get(`${PRODUCTS}/${id}`);
    return response.data;
}

export async function deleteProduct(product: Product) {
    await getAxiosInstance().delete(`${PRODUCTS}/${product.id}`);
    QUERY_CLIENT.invalidateQueries(QueryKeys.products);
}

export async function saveProduct(model: { object: Product, initialObject: Product }) {
    const response = await getAxiosInstance().patch(`${PRODUCTS}`, model.object);
    QUERY_CLIENT.invalidateQueries(QueryKeys.products);
    return response.data;
}

export async function updateProduct(product: Product) {
    await getAxiosInstance().patch(`${PRODUCTS}`, product);
    QUERY_CLIENT.invalidateQueries(QueryKeys.products);
}

export async function createProductAndGetId(product: Product): Promise<number> {
    const response: AxiosResponse<Product> = await getAxiosInstance().put(`${PRODUCTS}`, product);
    QUERY_CLIENT.invalidateQueries(QueryKeys.products);
    return response.data.id;
}

export async function createProduct(product: Product) {
    await getAxiosInstance().put(`${PRODUCTS}`, product);
    QUERY_CLIENT.invalidateQueries(QueryKeys.products);
}